"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoRaWANApplicationServer = exports.NetworkApplicationServer = exports.isNetworkApplicationServerLike = exports.DownlinkAction = exports.isAWS_LPWAN_NAS_ServerConfig = exports.isValid_AWS_LPWAN_NAS_InstanceType = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const core_services_1 = require("@iotv/core-services");
const constants_1 = require("../constants");
const ModelCommon_1 = require("./ModelCommon");
const ModelTypes_1 = require("../types/ModelTypes");
const { projectCode, stage } = process.env;
const isValid_AWS_LPWAN_NAS_InstanceType = (x) => {
    const c = x;
    return !!c && (x === 'LOCAL' || x === 'LNC' || x === 'LNC_HTTP');
};
exports.isValid_AWS_LPWAN_NAS_InstanceType = isValid_AWS_LPWAN_NAS_InstanceType;
const isAWS_LPWAN_NAS_ServerConfig = (x) => {
    const c = x;
    return !!c && (0, exports.isValid_AWS_LPWAN_NAS_InstanceType)(c.instanceType);
};
exports.isAWS_LPWAN_NAS_ServerConfig = isAWS_LPWAN_NAS_ServerConfig;
var DownlinkAction;
(function (DownlinkAction) {
    DownlinkAction["PUSH"] = "PUSH";
    DownlinkAction["REPLACE"] = "REPLACE";
})(DownlinkAction || (exports.DownlinkAction = DownlinkAction = {}));
const isNetworkApplicationServerLike = (ob) => {
    const cast = ob;
    const { Network, NetworkServerUrl, Applications, type } = cast;
    return ((0, iotv_v3_types_1.isValidBusinessObject)(ob) &&
        typeof Applications === 'object' &&
        type === constants_1.NetworkApplicationServerClassName &&
        Object.values(iotv_v3_types_1.Networks).includes(Network));
};
exports.isNetworkApplicationServerLike = isNetworkApplicationServerLike;
/** a.k.a. **LoRaWANApplicationServer** */
class NetworkApplicationServer extends ModelCommon_1.ModelCommon {
    constructor({ Applications, NetworkServerUrl, Network, name, DownlinkAuthenticationToken, id = (0, core_services_1.getApexNamedObjectId)({ type: constants_1.NetworkApplicationServerClassName, name }), ...others }) {
        super(constants_1.NetworkApplicationServerClassName, { name, id, ...others });
        this.Network = Network;
        this.NetworkServerUrl = NetworkServerUrl;
        this.Applications = Applications;
        this.DownlinkAuthenticationToken = DownlinkAuthenticationToken;
        if (others.OAuthID)
            this.OAuthID = others.OAuthID;
        if (others.OAuthSecret)
            this.OAuthSecret = others.OAuthSecret;
        if (!others._permittedAWOL) {
            this._permittedAWOL = iotv_v3_types_1.Milliseconds.MINUTE * 15;
        }
    }
    set permittedAWOL_MS(awolMs) {
        this._permittedAWOL = awolMs;
    }
    get permittedAWOL_MS() {
        return this._permittedAWOL;
    }
}
exports.NetworkApplicationServer = NetworkApplicationServer;
/** The exported Model class, required because the abstract cannot be used,
 * This class is not intended to be used directly, but rather to be extended by specific LNS implementations
 *  such as AWS, Chirpstack or Actility. The NetworkApplicationServerClassName is used to identify this class
 * in the ModelClasses map for dynamic instantiation by the BusinessObjectAssembler.
 */
class LoRaWANApplicationServer extends NetworkApplicationServer {
    constructor(props) {
        super(props);
        this.sendDownlink = async (downlinkParams) => {
            throw new Error('Method not implemented.');
        };
        this.listDownlinkQueue = async (params) => {
            throw new Error('Method not implemented.');
        };
        this.deviceIsRegistered = async (request) => {
            throw new Error('Method not implemented.');
        };
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            Network: { label: 'Network', type: 'Enum', required: true, enumKv: iotv_v3_types_1.Networks, editable: false },
            instanceType: {
                dependsOn: () => this.Network === 'AWS_LPWAN' ? { editable: false } : { hidden: true },
                label: 'AWS NAS Instance Type', type: 'Enum', required: true, enumKv: iotv_v3_types_1.AWS_LPWAN_NAS_InstanceTypes, editable: true
            },
            NetworkServerUrl: { label: 'Network Server URL', type: 'String', required: false, editable: true, },
            DownlinkAuthenticationToken: { label: 'Downlink Authentication Token', type: 'String', required: false, editable: true },
            OAuthID: { label: 'OAuth ID', type: 'String', required: false, editable: true },
            OAuthSecret: { label: 'OAuth Secret', type: 'String', required: false, editable: true },
            lastSeen: {
                type: 'Date',
                editable: false,
                label: 'Last Seen',
                name: 'lastSeen',
                precision: ModelTypes_1.UserAttributeKeyDatePrecision.DateTimeSecs,
                // displayFn: (actualValue: number | undefined) => (actualValue ? toDatePickerFormat(actualValue) : undefined),
                // valueFn: (newValue: number | undefined) => (newValue ? new Date(newValue).valueOf() : undefined),
            },
            isAWOL: { type: 'Boolean', editable: false, label: 'AWOL', name: 'isAWOL' },
            _permittedAWOL: {
                type: 'Number',
                editable: true,
                label: 'AWOL after',
                units: 'minutes',
                name: '_permittedAWOL',
                displayFn: (actualValue) => (actualValue ? actualValue / iotv_v3_types_1.Milliseconds.MINUTE : undefined),
                valueFn: (newValue) => (newValue ? newValue * iotv_v3_types_1.Milliseconds.MINUTE : undefined),
            },
        };
    }
}
exports.LoRaWANApplicationServer = LoRaWANApplicationServer;
